import LinkInOutApp from '@components/LinkInOutApp';
import { removeScripts } from '@utils/helper';

interface Props {
  item: any;
}

export const ItemNews = ({ item }: Props) => {
  return (
    <LinkInOutApp
      href={
        item?.slug
          ? `/tin-tuc/${item.slug}`
          : item?.id
          ? `/tin-tuc/${item.id}`
          : '#'
      }
      className="--item itemNews imgHover1 link"
    >
      <div className="--img">
        <img src={item?.imageThumbnails?.thumb1000} alt="" />
      </div>
      <div className="--txt">
        <div className="--cate">{item?.newscategory?.name}</div>
        <div className="--name">{item?.title}</div>
        <article
          dangerouslySetInnerHTML={{
            __html: removeScripts(item?.shortContent) || '',
          }}
        />
        <div className="--time">
          <i className="fa-regular fa-calendar"></i> {item?.date}
        </div>
      </div>
    </LinkInOutApp>
  );
};

export default ItemNews;
